<template>
  <div class="work-center">
   <!-- 搜索结果 -->
   <div v-show="searchshow"  class="search-zx">
      <div class="seach-zx-top">
        <span>当前位置：首页 > 搜索结果</span>
      </div>
      <div class="search-zx-bot">
        <p>共计有{{searchlength}}关于 “<span class="search-title">{{searchtit}}</span>”的搜索结果 </p>
      </div>
   </div>
   <!-- 排序 -->
    <div class="paixu">
      <span class="pxmode">排序方式：</span>
      <span @click="sorttime"  class="pxtime">时间</span>

      <!-- <span class="pxfen">|    |</span> -->
      <span @click="sortpraise" class="pxnum">票数</span>
      <!-- <img src="../images/筛选1 (1).png" alt="" style="vertical-align: middle;
    margin-left: 2px;" id="pxmax">
      <img src="../images/筛选1 (1) 拷贝.png" alt=" " style="vertical-align: middle;
    margin-left: 2px; display:none" id="pxmin"> -->

    </div>

<div class="zhongxin-listcont">

<div v-for="(item,index) in zhongxindata" :key="item.id" class="zhongxin-kelist">
         <div @click="zxbtnwk(index)" class="zhongxin-imgbtn">
           <img  class="zhongxin-kelist-img1"  :src="'http://ke.yunlearning.com:8081'+zhongxindata[index].cover_img" alt="###">
           </div>
           <p class="listp">{{zhongxindata[index].title}}</p>
           <span class="zhongxin-sp1">作品编号：A{{zhongxindata[index].number}}</span><span class="zhongxin-sp2">{{zhongxindata[index].praise}} 票</span>

           <div v-if="item.is_praise ==1" @click="zxbtntp(index)" class="zhongxin-btntas" type="button">
             <img src="../assets/toupiao2.png" alt="###">
             <span>{{zxtouptxts}}</span>
            </div>
            <div v-if="item.is_praise ==0" @click="zxbtntp(index)" class="zhongxin-btnta" type="button">
             <img src="../assets/toupiao2.png" alt="###">
             <span>{{zxtouptxt}}</span>
            </div>

    </div>
    <div class="zhongxin-pagination1" style="display:none">
      <div class="zx-pg">
 <el-pagination
  background
  layout="prev, pager, next"
  pager-count = 5
  :total="total"
   :page-size="perpage"
   :current-page="currentpage"
   :page-count="lastpage"
  @current-change="pageChange"
   >
</el-pagination>
      </div>

    </div>

     <div class="zhongxin-pagination2" style="display:block">
      <div class="zx-pg">
 <el-pagination
  background
  layout="prev, pager, next"
  pager-count = 5
  :total="total"
   :page-size="perpage"
   :current-page="currentpage"
   :page-count="lastpage"
  @current-change="pageChange1"
  >
</el-pagination>
      </div>

    </div>
  </div>
 <botTom></botTom>
  </div>
</template>

<script>
import axios from "axios"
import zhongxin from '../css/ZhongXin.css'
import botTom from './BotTom'
import PtSonVue from './PtSon.vue'

export default {
  data(){
    return{
      zhongxindata:[],//储存数据
      zxtouptxt:'为TA投票',
      zxtouptxts:'您已投票',
      iflist:true,
      searchlength:5,
      searchtit:'', //搜索的内容
      searchshow:false,
      total:2, //总数量
      perpage:10, //每页数量
      lastpage:10,//一共几页
      currentpage:1 ,//当前页
      typeid:1,
      order:'',
      page: 0
      // isAsc:true

    }
  },
  mounted(){
    if(this.page == 1){
      this.onloads();
    }else if(this.page == 0){
      this.onLoad();
    }
    if (this.searchtit=='') {
      this.searchshow = false;
    }else{
      this.searchshow = true;
    }

  },
  methods: {
    //数据请求
    onLoad(){
      if (JSON.parse(localStorage.getItem("userinfo"))==null) {
        axios({
          method:'post',
          url:this.$apiUrl+'/index.php/course/index',
          async: false,
          params:{
            page:this.currentpage,
            order:''
          },
          headers: {'content-type': "application/json; charset=utf-8"},
          // timeout: 1000,
        }).then(res=> {
          this.zhongxindata = res.data.data.data;
          //分页
          this.total = res.data.data.total; //总数量
          this.perpage =Number(res.data.data.per_page) //每页数量
          this.lastpage = res.data.data.last_page;//一共几页
        }).catch(error =>{
            console.log(error);
        })
        }
        else if (JSON.parse(localStorage.getItem("userinfo"))) {
          this.page = 0;
          let fas = new window.FormData;
          let tokens = JSON.parse(localStorage.getItem("userinfo")).token;
          fas.append('page',this.currentpage);
          fas.append('token',tokens)
          fas.append('title',this.searchtit)
          axios({
            method:'post',
            url:this.$apiUrl+'/index.php/course/index',
            data:fas,
            // timeout: 1000,
          }).then(res=> {
            this.zhongxindata = res.data.data.data;
            // console.log(this.zhongxindata);
            //分页
            this.total = res.data.data.total; //总数量
            this.perpage =Number(res.data.data.per_page) //每页数量
            this.lastpage = res.data.data.last_page;//一共几页
            //  this.typeid = res.data.data.type_id;
              this.searchlength = this.zhongxindata.length;
            // console.log(res)

          }).catch(error =>{
                console.log(error);
          })
        }
    },
    onloads(){
      if (JSON.parse(localStorage.getItem("userinfo"))==null) {
        axios({
          method:'post',
          url:this.$apiUrl+'/index.php/course/index',
          async: false,
          params:{
            page:this.currentpage,
            order:'praise_desc'
          },
          headers: {'content-type': "application/json; charset=utf-8"},
          // timeout: 1000,
        }).then(res=> {
          this.zhongxindata = res.data.data.data;
          //分页
          this.total = res.data.data.total; //总数量
          this.perpage =Number(res.data.data.per_page) //每页数量
          this.lastpage = res.data.data.last_page;//一共几页
        }).catch(error =>{
            console.log(error);
        })
        }
        else if (JSON.parse(localStorage.getItem("userinfo"))) {
          this.page = 1;
          let fas = new window.FormData;
          let tokens = JSON.parse(localStorage.getItem("userinfo")).token;
          fas.append('page',this.currentpage);
          fas.append('token',tokens)
          fas.append('title',this.searchtit)
          axios({
            method:'post',
            url:this.$apiUrl+'/index.php/course/index',
            params:{
              page:this.currentpage,
              order:'praise_desc'
            },
            data:fas,

            // timeout: 1000,
          }).then(res=> {
            this.zhongxindata = res.data.data.data;
            //分页
            this.total = res.data.data.total; //总数量
            this.perpage =Number(res.data.data.per_page) //每页数量
            this.lastpage = res.data.data.last_page;//一共几页
            //  this.typeid = res.data.data.type_id;
              this.searchlength = this.zhongxindata.length;
            // console.log(res)

          }).catch(error =>{
                console.log(error);
          })
        }
    },
    // 票数
    pageChange(currentpage){

      this.currentpage = currentpage;
      if(JSON.parse(localStorage.getItem("userinfo"))==null){
        return this.onloads();
      }else if(JSON.parse(localStorage.getItem("userinfo"))){
         var token = JSON.parse(localStorage.getItem("userinfo")).token
      }
      let fas = new window.FormData;
      fas.append('page',this.currentpage);
      axios({
        method:'post',
        url:this.$apiUrl+'/index.php/course/index',
        params:{
          page:this.currentpage,
          order:'praise_desc',
          token:token

        },
        headers: {'content-type': "application/json; charset=utf-8"},
        // timeout: 2000,
      }).then(res =>{
        this.onloads();
        this.zhongxindata = res.data.data.data;
        // console.log(res.data.data)
      })

    },
    // 时间
    pageChange1(currentpage){
      this.currentpage = currentpage;
      if(JSON.parse(localStorage.getItem("userinfo"))==null){
        return this.onLoad();
      }else if(JSON.parse(localStorage.getItem("userinfo"))){
         var token = JSON.parse(localStorage.getItem("userinfo")).token
      }

      let fas = new window.FormData;
            fas.append('page',this.currentpage);
        axios({
        method:'post',
        url:this.$apiUrl+'/index.php/course/index',
      params:{
          page:this.currentpage,
          order:'',
          token:token

        },
        headers: {'content-type': "application/json; charset=utf-8"},
        // timeout: 2000,
      }).then(res =>{
        this.onLoad();
        this.zhongxindata = res.data.data.data;
      })

    },
    // 点赞
    zxbtntp($event,index){
      //获取点击对象
      var elf = $event.currentTarget;

      let id = this.zhongxindata[$event].id; //作品ID
      // console.log(grid)

      // let grid = JSON.parse(sessionStorage.getItem('grid'));//个人作品ID
      let grid = JSON.parse(sessionStorage.getItem('res.data.data.id'));//个人作品ID
      // console.log(grid)id
      // let grid = JSON.stringify(sessionStorage.getItem('grid'));//个人作品ID
      // let grid = JSON.eval(sessionStorage.getItem('grid'))
      if (JSON.parse(localStorage.getItem("userinfo"))==null) {
        this.$confirm('请先登录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({path:'/denglu'});
        })
      }
      // else if (id == grid) {
      //   this.$message.error({
      //     message:'自己的作品自己不能投票！！！',
      //     offset:200
      //   })
      //   return false;
      // }
      else if (JSON.parse(localStorage.getItem("userinfo"))) {
        let token = JSON.parse(localStorage.getItem("userinfo")).token;

        let postdata = this.$qs.stringify({
            id:id,
            token:token
        });

        axios({
          method: 'post',

          url:this.$apiUrl+'/index.php/user/praise',
          data: postdata
        }).then(res=>{
          sessionStorage.setItem('grid',res.data.id);


          if (res.data.code==0){
        //  $event.target.innerHTML = ' 您已投过票';
        //  console.log($event.target);
        this.$message.error({
          message:'今日投票次数已用完，请明天再来！',
          offset:200,

        });
          }else if (res.data.code==1) {
            // $event.target.innerHTML = '投票成功';
            if(this.page == 1){
              this.onloads();
              // console.log(this.page)

            }else if(this.page == 0){
              this.onLoad();
            }

            this.$message({
              message:'投票成功！！！',
              offset:200,
              type:'success'
            });
          }
        }).catch(error=>{
          console.log(error);
        })
      }

    },
    // 票数排序
    sortpraise(){

      document.getElementsByClassName("zhongxin-pagination1")[0].style.display = "block";
      document.getElementsByClassName("zhongxin-pagination2")[0].style.display = "none";
      this.onloads()

      document.getElementsByClassName("pxtime")[0].style.color = "black";
      document.getElementsByClassName("pxnum")[0].style.color = "#0265BB";
    },

    //时间排序
    sorttime(){
      document.getElementsByClassName("zhongxin-pagination1")[0].style.display = "none";
      document.getElementsByClassName("zhongxin-pagination2")[0].style.display = "block";

      this.onLoad();
      document.getElementsByClassName("pxtime")[0].style.color = "#0265BB";
      document.getElementsByClassName("pxnum")[0].style.color = "black";
    }
    ,
    //点击封面跳转详情页
    zxbtnwk(index){
      // 将作品ID储存到VUEX中
      this.$store.commit('zuopbtnId',this.zhongxindata[index].id);
      if (JSON.parse(localStorage.getItem("userinfo"))==null) {
        this.$confirm('请先登录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({path:'/denglu'});
        })
      }else if (JSON.parse(localStorage.getItem("userinfo")).token) {
        this.$router.push({path:'/ptson'});
          let rzstutas = JSON.parse(localStorage.getItem('grxinxi')).status; //信息审核状
        if (rzstutas== -1) {
              this.$router.go(0);
        }
    }

},

},
components:{
  botTom
},
watch:{
  datatitle(data){
console.log(data,'watch');
// this.onLoad();
// this.onLoads();
  }
},
computed:{
  datatitle(){
    return this.searchtit = this.$store.state.title;

  }
}

}
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/ZhongXin.vue